<template>
  <div class="overview">
    <div class="overview__top">
      <div class="overview__top_left">
        <div class="overview__expire" >{{ t('Expire_date:') }}</div>
        <Popover :popoverDisabled="popoverDisabled">
          <template v-slot:content>
            <span>{{ t(expireDate) }}</span>
          </template>
          <template v-slot:popover>
            {{popoverText}}
          </template>
        </Popover>
      </div>
      <div class="overview__top_middle">
        <div class="overview__feedback">{{ t('Feedback_submitted') }}
          <div>
            <strong>{{feedbackSubmitted}}</strong>
            {{ t('of') }}
            <strong>{{initialData.candidates.length}}</strong>
            {{ t('candidates') }}
          </div>
        </div>
      </div>
      <div class="overview__top_right">
        <div class="overview__sender">
          <div class="sender__title">{{ t('Presented by') }}</div>
          <div class="sender__obj">
            <div class="sender__left">
              <svg v-if="!initialData.sender.img" width="34" height="34" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28 0C12.5323 0 0 12.5323 0 28C0 43.4677 12.5323 56 28 56C43.4677 56 56 43.4677 56 28C56 12.5323 43.4677 0 28 0ZM28 10.8387C33.4871 10.8387 37.9355 15.2871 37.9355 20.7742C37.9355 26.2613 33.4871 30.7097 28 30.7097C22.5129 30.7097 18.0645 26.2613 18.0645 20.7742C18.0645 15.2871 22.5129 10.8387 28 10.8387ZM28 49.6774C21.3726 49.6774 15.4339 46.6742 11.4597 41.9774C13.5823 37.9806 17.7371 35.2258 22.5806 35.2258C22.8516 35.2258 23.1226 35.271 23.3823 35.35C24.85 35.8242 26.3855 36.129 28 36.129C29.6145 36.129 31.1613 35.8242 32.6177 35.35C32.8774 35.271 33.1484 35.2258 33.4194 35.2258C38.2629 35.2258 42.4177 37.9806 44.5403 41.9774C40.5661 46.6742 34.6274 49.6774 28 49.6774Z" fill="#EDECF2"/><path d="M37.9356 20.7739C37.9356 15.2868 33.4872 10.8384 28.0001 10.8384C22.513 10.8384 18.0646 15.2868 18.0646 20.7739C18.0646 26.261 22.513 30.7093 28.0001 30.7093C33.4872 30.7093 37.9356 26.261 37.9356 20.7739Z" fill="#C7C7CC"/><path d="M11.4594 41.9772C15.4336 46.674 21.3723 49.6772 27.9997 49.6772C34.6272 49.6772 40.5659 46.674 44.5401 41.9772C42.4175 37.9804 38.2626 35.2256 33.4191 35.2256C33.1481 35.2256 32.8772 35.2707 32.6175 35.3498C31.161 35.824 29.6143 36.1288 27.9997 36.1288C26.3852 36.1288 24.8497 35.824 23.382 35.3498C23.1223 35.2707 22.8514 35.2256 22.5804 35.2256C17.7368 35.2256 13.582 37.9804 11.4594 41.9772Z" fill="#C7C7CC"/><circle cx="28" cy="28" r="27.5" stroke="#BBBBBB"/></svg>
              <img class="sender__img" v-else :src="initialData.sender.img"  alt="Sender Image">
            </div>
            <div class="sender__right">
              <div class="sender__name">{{senderName}}</div>
              <div class="sender__title" v-if="initialData.sender.title">{{initialData.sender.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sender">
      <div class="sender__title">{{ t('Presented by') }}</div>
      <div class="sender__obj">
        <div class="sender__left">
          <svg v-if="!initialData.sender.img" width="34" height="34" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28 0C12.5323 0 0 12.5323 0 28C0 43.4677 12.5323 56 28 56C43.4677 56 56 43.4677 56 28C56 12.5323 43.4677 0 28 0ZM28 10.8387C33.4871 10.8387 37.9355 15.2871 37.9355 20.7742C37.9355 26.2613 33.4871 30.7097 28 30.7097C22.5129 30.7097 18.0645 26.2613 18.0645 20.7742C18.0645 15.2871 22.5129 10.8387 28 10.8387ZM28 49.6774C21.3726 49.6774 15.4339 46.6742 11.4597 41.9774C13.5823 37.9806 17.7371 35.2258 22.5806 35.2258C22.8516 35.2258 23.1226 35.271 23.3823 35.35C24.85 35.8242 26.3855 36.129 28 36.129C29.6145 36.129 31.1613 35.8242 32.6177 35.35C32.8774 35.271 33.1484 35.2258 33.4194 35.2258C38.2629 35.2258 42.4177 37.9806 44.5403 41.9774C40.5661 46.6742 34.6274 49.6774 28 49.6774Z" fill="#EDECF2"/><path d="M37.9356 20.7739C37.9356 15.2868 33.4872 10.8384 28.0001 10.8384C22.513 10.8384 18.0646 15.2868 18.0646 20.7739C18.0646 26.261 22.513 30.7093 28.0001 30.7093C33.4872 30.7093 37.9356 26.261 37.9356 20.7739Z" fill="#C7C7CC"/><path d="M11.4594 41.9772C15.4336 46.674 21.3723 49.6772 27.9997 49.6772C34.6272 49.6772 40.5659 46.674 44.5401 41.9772C42.4175 37.9804 38.2626 35.2256 33.4191 35.2256C33.1481 35.2256 32.8772 35.2707 32.6175 35.3498C31.161 35.824 29.6143 36.1288 27.9997 36.1288C26.3852 36.1288 24.8497 35.824 23.382 35.3498C23.1223 35.2707 22.8514 35.2256 22.5804 35.2256C17.7368 35.2256 13.582 37.9804 11.4594 41.9772Z" fill="#C7C7CC"/><circle cx="28" cy="28" r="27.5" stroke="#BBBBBB"/></svg>
          <img class="sender__img" v-else :src="initialData.sender.img"  alt="Sender Image">
        </div>
        <div class="sender__right">
          <div class="sender__name">{{senderName}}</div>
          <div class="sender__title" v-if="initialData.sender.title">{{initialData.sender.title}}</div>
        </div>
      </div>
    </div>

    <div v-if="initialData" class="overview__presentation">
      <span v-html="initialData.presentation.body"></span>
      <div class="overview__files" v-if="initialData.attachments.length">
        <h2 class="overview__files-title">{{ t('Files') }}</h2>

        <div class="file" v-for="attachment in initialData.attachments" :key="attachment.name">
          <div class="file__inner" v-if="!attachment.hasVirus">
            <Popover :popoverDisabled="!attachment.hasPreview">
              <template v-slot:content>
                <div class="file__left">
                  <div class="file__left_img-container">
                    <svg v-if="filePreviewLoading && fileNameLoading === attachment.name" class="file__loader" xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="5 -10 25 60" stroke="#1E88E5" ><g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="2">
                      <circle stroke="#E5E5EA" cx="18" cy="18" r="18"/>
                      <path d="M36 18c0-9.94-8.06-18-18-18">
                        <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/>
                      </path>
                    </g></g></svg>
                    <img v-else :src="getIcon(attachment.ext)" alt="attachment">
                  </div>
                  <div class="file__info">
                    <div class="file__info-left">
                      <div class="file__name" @click="fileNameClickHandler(attachment)">
                        <span>{{attachment.name}}</span>
                      </div>
                      <div class="file__size">{{getFileSize(attachment.size)}}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:popover>
                {{ t('Preview file') }}
              </template>
            </Popover>

            <button class="file__download">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8996 3.5001C12.8996 3.00304 12.4967 2.6001 11.9996 2.6001C11.5026 2.6001 11.0996 3.00304 11.0996 3.5001L11.0996 14.3273L8.63601 11.8637C8.28453 11.5122 7.71469 11.5122 7.36321 11.8637C7.01174 12.2152 7.01174 12.785 7.36321 13.1365L11.3632 17.1365C11.532 17.3053 11.7609 17.4001 11.9996 17.4001C12.2383 17.4001 12.4672 17.3053 12.636 17.1365L16.636 13.1365C16.9875 12.785 16.9875 12.2152 16.636 11.8637C16.2845 11.5122 15.7147 11.5122 15.3632 11.8637L12.8996 14.3273V3.5001ZM1.99961 16.6001C2.49667 16.6001 2.89961 17.003 2.89961 17.5001V19.0001C2.89961 19.3355 3.16711 19.6001 3.49441 19.6001H3.51443H3.53455H3.55479H3.57514H3.59561H3.61618H3.63686H3.65765H3.67855H3.69957H3.72069H3.74191H3.76325H3.78469H3.80624H3.8279H3.84967H3.87154H3.89351H3.9156H3.93778H3.96008H3.98247H4.00497H4.02758H4.05029H4.0731H4.09601H4.11903H4.14215H4.16537H4.18869H4.21211H4.23564H4.25926H4.28298H4.30681H4.33073H4.35475H4.37887H4.40309H4.4274H4.45181H4.47632H4.50093H4.52563H4.55043H4.57533H4.60032H4.6254H4.65058H4.67585H4.70122H4.72668H4.75224H4.77788H4.80362H4.82945H4.85538H4.88139H4.9075H4.93369H4.95998H4.98636H5.01282H5.03938H5.06602H5.09276H5.11958H5.14649H5.17348H5.20057H5.22774H5.25499H5.28234H5.30977H5.33728H5.36488H5.39256H5.42033H5.44818H5.47612H5.50414H5.53224H5.56042H5.58869H5.61704H5.64547H5.67398H5.70257H5.73124H5.75999H5.78882H5.81773H5.84672H5.87579H5.90494H5.93416H5.96347H5.99285H6.0223H6.05184H6.08144H6.11113H6.14089H6.17072H6.20063H6.23062H6.26068H6.29081H6.32101H6.35129H6.38164H6.41207H6.44256H6.47313H6.50377H6.53448H6.56525H6.5961H6.62702H6.65801H6.68907H6.72019H6.75139H6.78265H6.81398H6.84538H6.87684H6.90837H6.93997H6.97163H7.00336H7.03516H7.06702H7.09894H7.13093H7.16298H7.19509H7.22727H7.25951H7.29181H7.32417H7.3566H7.38909H7.42163H7.45424H7.48691H7.51964H7.55243H7.58527H7.61818H7.65114H7.68417H7.71725H7.75038H7.78358H7.81683H7.85014H7.8835H7.91692H7.95039H7.98392H8.0175H8.05114H8.08483H8.11858H8.15238H8.18623H8.22013H8.25409H8.28809H8.32215H8.35626H8.39042H8.42463H8.45889H8.4932H8.52756H8.56196H8.59642H8.63092H8.66548H8.70008H8.73472H8.76942H8.80415H8.83894H8.87377H8.90865H8.94357H8.97854H9.01355H9.0486H9.0837H9.11884H9.15402H9.18925H9.22452H9.25983H9.29518H9.33057H9.366H9.40148H9.43699H9.47254H9.50813H9.54377H9.57944H9.61514H9.65089H9.68667H9.72249H9.75835H9.79424H9.83017H9.86614H9.90214H9.93818H9.97425H10.0104H10.0465H10.0827H10.1189H10.1551H10.1914H10.2277H10.264H10.3004H10.3368H10.3732H10.4097H10.4462H10.4827H10.5192H10.5558H10.5924H10.629H10.6657H10.7024H10.7391H10.7759H10.8126H10.8494H10.8862H10.9231H10.96H10.9969H11.0338H11.0707H11.1077H11.1447H11.1817H11.2187H11.2558H11.2929H11.33H11.3671H11.4043H11.4414H11.4786H11.5158H11.553H11.5903H11.6276H11.6648H11.7021H11.7395H11.7768H11.8141H11.8515H11.8889H11.9263H11.9637H12.0011H12.0386H12.076H12.1135H12.151H12.1885H12.226H12.2636H12.3011H12.3386H12.3762H12.4138H12.4514H12.489H12.5266H12.5642H12.6018H12.6394H12.6771H12.7147H12.7524H12.7901H12.8277H12.8654H12.9031H12.9408H12.9785H13.0162H13.0539H13.0916H13.1294H13.1671H13.2048H13.2426H13.2803H13.318H13.3558H13.3935H13.4313H13.469H13.5068H13.5445H13.5822H13.62H13.6577H13.6955H13.7332H13.771H13.8087H13.8465H13.8842H13.9219H13.9597H13.9974H14.0351H14.0728H14.1105H14.1483H14.186H14.2237H14.2614H14.299H14.3367H14.3744H14.4121H14.4497H14.4874H14.525H14.5626H14.6002H14.6379H14.6755H14.7131H14.7506H14.7882H14.8258H14.8633H14.9008H14.9384H14.9759H15.0134H15.0508H15.0883H15.1258H15.1632H15.2006H15.238H15.2754H15.3128H15.3502H15.3875H15.4248H15.4622H15.4994H15.5367H15.574H15.6112H15.6484H15.6856H15.7228H15.76H15.7971H15.8342H15.8713H15.9084H15.9454H15.9825H16.0195H16.0564H16.0934H16.1303H16.1672H16.2041H16.241H16.2778H16.3146H16.3514H16.3882H16.4249H16.4616H16.4983H16.5349H16.5716H16.6082H16.6447H16.6813H16.7178H16.7542H16.7907H16.8271H16.8635H16.8998H16.9362H16.9724H17.0087H17.0449H17.0811H17.1173H17.1534H17.1895H17.2255H17.2616H17.2975H17.3335H17.3694H17.4053H17.4411H17.4769H17.5127H17.5484H17.5841H17.6198H17.6554H17.691H17.7265H17.762H17.7974H17.8329H17.8682H17.9036H17.9389H17.9741H18.0093H18.0445H18.0796H18.1147H18.1497H18.1847H18.2196H18.2545H18.2894H18.3242H18.359H18.3937H18.4284H18.463H18.4976H18.5321H18.5666H18.601H18.6354H18.6697H18.704H18.7383H18.7724H18.8066H18.8407H18.8747H18.9087H18.9426H18.9765H19.0103H19.0441H19.0778H19.1115H19.1451H19.1787H19.2122H19.2456H19.279H19.3123H19.3456H19.3788H19.412H19.4451H19.4782H19.5112H19.5441H19.577H19.6098H19.6426H19.6753H19.7079H19.7405H19.773H19.8055H19.8379H19.8702H19.9025H19.9347H19.9668H19.9989H20.0309H20.0629H20.0948H20.1266H20.1584H20.1901H20.2217H20.2533H20.2848H20.3162H20.3476H20.3789H20.4101H20.4413H20.4724H20.5034C20.8318 19.6001 21.0996 19.3344 21.0996 19.0001V17.5001C21.0996 17.003 21.5026 16.6001 21.9996 16.6001C22.4967 16.6001 22.8996 17.003 22.8996 17.5001V19.0001C22.8996 20.3226 21.8319 21.4001 20.5034 21.4001H20.4724H20.4413H20.4101H20.3789H20.3476H20.3162H20.2848H20.2533H20.2217H20.1901H20.1584H20.1266H20.0948H20.0629H20.0309H19.9989H19.9668H19.9347H19.9025H19.8702H19.8379H19.8055H19.773H19.7405H19.7079H19.6753H19.6426H19.6098H19.577H19.5441H19.5112H19.4782H19.4451H19.412H19.3788H19.3456H19.3123H19.279H19.2456H19.2122H19.1787H19.1451H19.1115H19.0778H19.0441H19.0103H18.9765H18.9426H18.9087H18.8747H18.8407H18.8066H18.7724H18.7383H18.704H18.6697H18.6354H18.601H18.5666H18.5321H18.4976H18.463H18.4284H18.3937H18.359H18.3242H18.2894H18.2545H18.2196H18.1847H18.1497H18.1147H18.0796H18.0445H18.0093H17.9741H17.9389H17.9036H17.8682H17.8329H17.7974H17.762H17.7265H17.691H17.6554H17.6198H17.5841H17.5484H17.5127H17.4769H17.4411H17.4053H17.3694H17.3335H17.2975H17.2616H17.2255H17.1895H17.1534H17.1173H17.0811H17.0449H17.0087H16.9724H16.9362H16.8998H16.8635H16.8271H16.7907H16.7542H16.7178H16.6813H16.6447H16.6082H16.5716H16.5349H16.4983H16.4616H16.4249H16.3882H16.3514H16.3146H16.2778H16.241H16.2041H16.1672H16.1303H16.0934H16.0564H16.0195H15.9825H15.9454H15.9084H15.8713H15.8342H15.7971H15.76H15.7228H15.6856H15.6484H15.6112H15.574H15.5367H15.4994H15.4622H15.4248H15.3875H15.3502H15.3128H15.2754H15.238H15.2006H15.1632H15.1258H15.0883H15.0508H15.0134H14.9759H14.9384H14.9008H14.8633H14.8258H14.7882H14.7506H14.7131H14.6755H14.6379H14.6002H14.5626H14.525H14.4874H14.4497H14.4121H14.3744H14.3367H14.299H14.2614H14.2237H14.186H14.1483H14.1105H14.0728H14.0351H13.9974H13.9597H13.9219H13.8842H13.8465H13.8087H13.771H13.7332H13.6955H13.6577H13.62H13.5822H13.5445H13.5068H13.469H13.4313H13.3935H13.3558H13.318H13.2803H13.2426H13.2048H13.1671H13.1294H13.0916H13.0539H13.0162H12.9785H12.9408H12.9031H12.8654H12.8277H12.7901H12.7524H12.7147H12.6771H12.6394H12.6018H12.5642H12.5266H12.489H12.4514H12.4138H12.3762H12.3386H12.3011H12.2636H12.226H12.1885H12.151H12.1135H12.076H12.0386H12.0011H11.9637H11.9263H11.8889H11.8515H11.8141H11.7768H11.7395H11.7021H11.6648H11.6276H11.5903H11.553H11.5158H11.4786H11.4414H11.4043H11.3671H11.33H11.2929H11.2558H11.2187H11.1817H11.1447H11.1077H11.0707H11.0338H10.9969H10.96H10.9231H10.8862H10.8494H10.8126H10.7759H10.7391H10.7024H10.6657H10.629H10.5924H10.5558H10.5192H10.4827H10.4462H10.4097H10.3732H10.3368H10.3004H10.264H10.2277H10.1914H10.1551H10.1189H10.0827H10.0465H10.0104H9.97425H9.93818H9.90214H9.86614H9.83017H9.79424H9.75835H9.72249H9.68667H9.65089H9.61514H9.57944H9.54377H9.50813H9.47254H9.43699H9.40148H9.366H9.33057H9.29518H9.25983H9.22452H9.18925H9.15402H9.11884H9.0837H9.0486H9.01355H8.97854H8.94357H8.90865H8.87377H8.83894H8.80415H8.76942H8.73472H8.70008H8.66548H8.63092H8.59642H8.56196H8.52756H8.4932H8.45889H8.42463H8.39042H8.35626H8.32215H8.28809H8.25409H8.22013H8.18623H8.15238H8.11858H8.08483H8.05114H8.0175H7.98392H7.95039H7.91692H7.8835H7.85014H7.81683H7.78358H7.75038H7.71725H7.68417H7.65114H7.61818H7.58527H7.55243H7.51964H7.48691H7.45424H7.42163H7.38909H7.3566H7.32417H7.29181H7.25951H7.22727H7.19509H7.16298H7.13093H7.09894H7.06702H7.03516H7.00336H6.97163H6.93997H6.90837H6.87684H6.84538H6.81398H6.78265H6.75139H6.72019H6.68907H6.65801H6.62702H6.5961H6.56525H6.53448H6.50377H6.47313H6.44256H6.41207H6.38164H6.35129H6.32101H6.29081H6.26068H6.23062H6.20063H6.17072H6.14089H6.11113H6.08144H6.05184H6.0223H5.99285H5.96347H5.93416H5.90494H5.87579H5.84672H5.81773H5.78882H5.75999H5.73124H5.70257H5.67398H5.64547H5.61704H5.58869H5.56042H5.53224H5.50414H5.47612H5.44818H5.42033H5.39256H5.36488H5.33728H5.30977H5.28234H5.25499H5.22774H5.20057H5.17348H5.14649H5.11958H5.09276H5.06602H5.03938H5.01282H4.98636H4.95998H4.93369H4.9075H4.88139H4.85538H4.82945H4.80362H4.77788H4.75224H4.72668H4.70122H4.67585H4.65058H4.6254H4.60032H4.57533H4.55043H4.52563H4.50093H4.47632H4.45181H4.4274H4.40309H4.37887H4.35475H4.33073H4.30681H4.28298H4.25926H4.23564H4.21211H4.18869H4.16537H4.14215H4.11903H4.09601H4.0731H4.05029H4.02758H4.00497H3.98247H3.96008H3.93778H3.9156H3.89351H3.87154H3.84967H3.8279H3.80624H3.78469H3.76325H3.74191H3.72069H3.69957H3.67855H3.65765H3.63686H3.61618H3.59561H3.57514H3.55479H3.53455H3.51443H3.49441C2.16486 21.4001 1.09961 20.3215 1.09961 19.0001V17.5001C1.09961 17.003 1.50255 16.6001 1.99961 16.6001Z" fill="#19191A"/>
              </svg>
              <span class="file__download-text" @click="downloadFileClickHandler(attachment)">
                {{ t('Download') }}
              </span>
            </button>

          </div>
        </div>

      </div>
    </div>
    <div class="overview__candidate_list">
      <CandidateListItem  v-for="(item, index) in initialData.candidates" :index="index" :candidate="item" :key="item.presentationId" :lastCandidate="index === initialData.candidates.length - 1" />
    </div>
    <FilePreview
        v-if="showPreview"
        @close="showPreview = false"
        :filePreview="filePreview"
        :attachment="selectedAttachment"
    />
    <PdfModal
        v-if="isModalOpen"
        :pdfUrl="pdfUrl"
        :isOpen="isModalOpen"
        @close="isModalOpen = false"
        :filePreview="filePreview"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { useI18n } from 'vue-i18n';
import moment from 'moment';
import { bytesToSize, getFileIcon } from '../utils';
import { request } from '../api/APIService';
import CandidateListItem from '../components/CandidateListItem';
import Popover from '../components/Popover';
import FilePreview from '../components/FilePreview.vue';
import PdfModal from '../components/PdfModal.vue';

export default {
  components: {
    PdfModal,
    FilePreview,
    CandidateListItem,
    Popover,
  },
  setup(){
    const { t } = useI18n();
    return { t };
  },
  data(){
    return{
      expireDate: '',
      popoverDisabled: false,
      popoverText: '',
      filePreview: {
        fileName: '',
        iconUrl: ''
      },
      showPreview: false,
      selectedAttachment: null,
      fileDownloadingCompleted: true,
      filePreviewLoading: false,
      fileNameLoading: '',
      isModalOpen: false,
      pdfUrl: ''
    }
  },
  mounted(){
    const expiredDate = moment(this.presentationData.endDate);
    const dateNow = moment();
    const dateTomorrow = moment().add(1,'days');

    this.expireDate = "Tomorrow";
    this.popoverText = expiredDate.format('DD.MM.YYYY');

    if(expiredDate.isSame(dateNow, 'd')){
      this.expireDate = "Today";
      this.popoverText = expiredDate.format('DD.MM.YYYY');
    }
    else if(expiredDate.isSame(dateTomorrow, 'd')){
      this.expireDate = "Tomorrow";
      this.popoverText = expiredDate.format('DD.MM.YYYY');
    }
    else{
      this.expireDate = expiredDate.format('DD.MM.YYYY');
      this.popoverDisabled = true;
    }
  },
  computed: {
    ...mapState([
      'initialData',
      'presentationData',
      'lang',
      'key'
    ]),
    feedbackSubmitted() {
      let result = 0;

      if (this.initialData.candidates.length) {
        this.initialData.candidates.forEach((candidate) => {
          candidate.reviews.forEach(review => {
            if (!review.fromReceiver) {
              result++;
            }
          });
        });
      }
      return result;
    },
    senderName(){
      return this.initialData.sender ? this.initialData.sender.firstName + ' ' + this.initialData.sender.lastName : '';
    }
  },
  methods: {
    getIcon(extension) {
      return getFileIcon(extension);
    },
    getFileSize(bytes) {
      return bytesToSize(bytes);
    },
    getDownloadLink(candidatePresentationAttachmentId){
      return `api/?key=${this.key}&presentationId=${this.presentationData.id}&candidatePresentationAttachmentId=${candidatePresentationAttachmentId}&scope=downloadOverviewAttachment`;
    },
    fileNameClickHandler(attachment){
      if(attachment.hasPreview){
        this.fetchAttachmentPreview(attachment);
      } else {
        this.downloadFileClickHandler(attachment);
      }
    },
    downloadFileClickHandler(attachment){
      const linkElement = document.createElement('a');
      linkElement.href = this.getDownloadLink(attachment.candidatePresentationAttachmentId);
      linkElement.click();
    },
    async fetchAttachmentPreview(attachment){
      this.filePreviewLoading = true;
      this.fileNameLoading = attachment.name;

      let data = {
        key: this.key,
        scope: 'fetchOverviewAttachmentPreview',
        candidatePresentationAttachmentId: attachment.candidatePresentationAttachmentId
      }

      try {
        let res = await request(data);

        if (res.data.success) {
          this.filePreview.fileName = attachment.name;
          this.filePreview.iconUrl = this.getIcon(attachment.ext);
          this.filePreview.downloadLink = this.getDownloadLink(attachment.candidatePresentationAttachmentId);

          this.selectedAttachment = res.data.data;

          if (res.data.data.ext === 'pdf') {
            this.pdfUrl = `data:application/pdf;base64,${this.selectedAttachment.files[0].base64}`;
            this.isModalOpen = true;
          } else {
            this.showPreview = true;
          }
        }
      }
      catch (e) {
        console.dir(e);
      }
      finally {
        this.filePreviewLoading = false;
        this.fileNameLoading = '';
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.overview{
  padding-top: 30px;
}

.overview__top{
  margin: 0 auto;
  padding: 0 0 0 20px;
  max-width: 635px;
  box-sizing: border-box;
  display: flex;

  @media (min-width: 635px){
    justify-content: space-between;
  }

  .overview__top_left{
    display: flex;
    justify-content: center;
    flex-direction: column;
    box-sizing: border-box;
    min-height: 60px;
    min-width: 40%;

    @media (min-width: 635px){
      min-width: 15%;
    }
  }

  .overview__top_middle{
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    min-height: 60px;
    border-left: 1px solid #E5E5EA;
    padding: 0 20px;
    min-width: 60%;

    @media (min-width: 635px){
      border-right: 1px solid #E5E5EA;
      min-width: inherit;
    }
  }

  .overview__top_right{
    display: none;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    padding-left: 10px;
    min-height: 60px;

    @media (min-width: 635px){
      display: flex;
      position: relative;
    }
  }

  .popover__container{
    font-size: 12px;
    line-height: 16px;
    color: #333;
    align-self: flex-start;
  }
}

.sender__obj{
  display: flex;
  align-items: center;
}

.sender__left{
  margin-right: 10px;
}

.sender__img{
  width: 34px;
  height: 34px;
  object-fit: cover;
  border-radius: 50%;
}

.sender__name{
  font-size: 12px;
  line-height: 16px;
  color: #333;
  white-space: nowrap;
}

.sender__title{
  font-size: 12px;
  line-height: 16px;
  color: #999;
  margin-bottom: 7px;
  white-space: nowrap;
}

.overview__feedback{
  font-size: 12px;
  line-height: 16px;
  color: #333;
  white-space: nowrap;
}

.overview__expire{
  font-size: 12px;
  line-height: 16px;
  color: #999;
  display: flex;

  span{
    color: #333;
    margin-left: 3px;
  }
}

.popover__container{
  position: relative;
}

.overview__candidate_list{
  margin: 12px auto 0;
  max-width: 635px;
}

.overview__presentation {
  margin: 0 auto;
  padding: 36px 20px;
  max-width: 635px;
  box-sizing: border-box;
}

.sender{
  display: block;
  margin: 20px 20px 40px;

  @media (min-width: 635px){
    display: none;
  }

  @media print  and (max-width: 635px){
    margin-left: 60px;
  }
}

.overview__files {
  margin: 36px 0 0;
  &-title {
    line-height: 16px;
    color: #999;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
  }

  .file{
    margin-bottom: 12px;
    transition: background-color .2s ease-in-out;
    padding: 4px 0;
    border-bottom: 1px solid #EAEAEB;

    &:last-child{
      margin-bottom: 0;
    }

    &:hover{
      background-color: rgb(153, 153, 153, .1);

      .file__download {
        opacity: 1;
      }
    }

    .file__inner{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .file__left{
      display: flex;
      align-items: center;
      margin-left: 5px;
    }

    .file__left_img-container{
      position: relative;
    }

    a{
      text-decoration: none;
      display: flex;
      align-items: baseline;
    }

    img{
      width: 30px;
      height: 40px;
      border-radius: 0;
    }

    .file__download{
      border: none;
      background-color: transparent;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: #0C0C0D;
      margin-right: 20px;
      transition: all .2s ease-in-out;
      margin-left: 15px;
      display: flex;
      align-items: inherit;
      cursor: pointer;
      padding: 6px;

      &:hover{
        color: #000;
        background-color: #3231311a;
      }

      @media (min-width: 500px){
        margin-left: 40px;
      }

      @media (min-width: 635px){
        opacity: 0;
      }

      svg{
        margin-right: 6px;
        width: 20px;
        height: 20px;

        @media (min-width: 635px){
          width: 12px;
          height: 12px;
        }
      }

      &-text {
        display: none;

        @media (min-width: 635px){
          display: inline;
        }
      }
    }
  }

  .files__title{
    margin: 0 0 24px 0;
    border: 0;
  }

  .file__info{
    margin-left: 10px;
    display: flex;
    align-items: center;
    gap: 16px;

    &-download {
      border: 0;
      background: none;
      cursor: pointer;
      font-size: 14px;
    }

    .file__name{
      font-weight: bold;
      font-size: 12px;
      line-height: 18px;
      color: #333;
      cursor: pointer;
      position: relative;
      word-break: break-word;

      span:hover{
        position: relative;
        cursor: pointer;

        &:before{
          position: absolute;
          left: 0;
          bottom: 0;
          right: 0;
          content: '';
          height: 1px;
          background-color: #000;
          width: 100%;
        }
      }
    }

    .file__size{
      font-size: 12px;
      line-height: 16px;
      color: #999;
    }
  }
}
</style>
